export const login = async data => {
  return await window.$vue.$post({
    endpoint: "/auth/sign-in",
    data: data
  })
}

export const verify = async data => {
  return await window.$vue.$post({ endpoint: "/auth/verify", data: data })
}

export const resetPassword = async data => {
  return await window.$vue.$post({
    endpoint: "/user/reset-password",
    data: data
  })
}

export const sendResetPassword = async data => {
  return await window.$vue.$post({
    endpoint: "/user/send-reset-password",
    data: data
  })
}

export const changeMyPassword = async (uuid, data) => {
  return await window.$vue.$put({
    endpoint: `/me/${uuid}/change-password`,
    data: data
  })
}

export const changeMyUserPhoto = async (uuid, data) => {
  return await window.$vue.$put({ endpoint: `/me/${uuid}/photo`, data: data })
}

export const fetchRoles = async () => {
  return await window.$vue.$get({
    endpoint: "/role"
  })
}

export const updateMyAccount = async (uuid, data) => {
  return await window.$vue.$put({ endpoint: `/me/${uuid}`, data: data })
}

export const generateToken = async data => {
  return await window.$vue.$post({
    endpoint: "/security/generate-token",
    data: data
  })
}

export const resendToken = async data => {
  return await window.$vue.$post({
    endpoint: "/security/resend-token",
    data: data
  })
}

export const validateToken = async data => {
  return await window.$vue.$post({
    endpoint: "/security/validate-token",
    data: data
  })
}

export const getSendTokenTypes = async () => {
  return await window.$vue.$get({
    endpoint: "/security/mfa-send-types"
  })
}

export const sendContactToken = async (contactType, data) => {
  return await window.$vue.$post({
    endpoint: `/contact-confirmation/${contactType}/send`,
    data: data
  })
}

export const resendContactToken = async (contactType, data) => {
  return await window.$vue.$post({
    endpoint: `/contact-confirmation/${contactType}/renew-token`,
    data: data
  })
}

export const validateContactToken = async (contactType, data) => {
  return await window.$vue.$post({
    endpoint: `/contact-confirmation/${contactType}/validate`,
    data: data
  })
}